goog.provide('el8.appchart.letters.selectAttachments');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.letters.attachmentGroups');
goog.require('el8.appchart.letters.relatedAttachmentsPrompt');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appservice.notifier');
goog.require('el8.data.educationalHandouts');
goog.require('el8.model.identify');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.letters');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters');
goog.require('el8.template.appchart.letters.selectAttachments');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.GroupedNav');
goog.require('el8.util.consts');


/**
 * This dialog manages the selection of chart items to attach to a Letter, in combination
 * with the attachmentGroups file, which defines the feeds the make up this dialog.
 *
 * There are two points at which a previously selected attachment can be highlighted (i.e., appear selected):
 * 1. In attachmentGroups, the template function which renders attachments gets passed
 *    a boolean representing whether newly rendered items should be highlighted.
 * 2. In this file's show() fn, we call doHighlight() which makes sure that any currently
 *    attached items show up as highlighted (but won't do anything for objects that haven't
 *    been fetched yet).
 * This combo implies some redundancy but ensures that both items that haven't been fetched
 * yet and items that have been fetched when the dialog was previously opened have an
 * in-sync highlighted state.
 */
el8.appchart.letters.selectAttachments = (function() {

    var groupedNav = null;
    var groups = null;

    var attachedItems = {};
    var callbackFn = null; //won't error if null, but this dialog is pretty useless without one

    var that = new el8.uiwidget.NewDialog({
        title: 'Attach Chart Items',
        modal: true,
        height: function() {
            return el8.app.pageLayout.getAppInnerHeight();
        },
        width: 800,
        contentFn: function() {
            return el8.template.appchart.letters.selectAttachments.content({
                attachments: []
            });
        },
        showXButton: el8Globals.READ_ONLY
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Attach Items', function() {
            if (callbackFn) {
                callbackFn(_.values(attachedItems));
            }
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'cancel', 'Discard Changes', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        // setup attachmentGroups so it can initialize all the feeds
        groups = el8.appchart.letters.attachmentGroups.groups();
        el8.appchart.letters.attachmentGroups.setIsAttachedFn(checkIsAttached);
        groupedNav = new el8.uiwidget.GroupedNav({
            navContainer: $('.select-attachments-nav', that.getContentElt()),
            contentContainer: $('.select-attachments-content', that.getContentElt())
        });
        groupedNav.init({ groups: groups });

        bindTriggers();
    };

    var super_show = that.show;
    /* Spec takes a callbackFn, list of current attachments (real objects),
     * and a list of attached printouts (which don't have IDs)
     *
     * callbackFn will get called with:
     *    + a list of soy maps of attached items
     *    + a list of strings of attached printouts
     * attachments should be a list of soy maps
     */
    that.show = function(spec) {
        callbackFn = spec.callbackFn || null;

        super_show.call(that); //needs to come first so groupedNav is defined
        groupedNav.showSection('popular');
        that.adjustPosition();

        if (spec.isPassport) {
            groupedNav.showSectionTab('handouts');
            groupedNav.showSectionTab('growthcharts');
            groupedNav.hideSectionTab('prenatalfs');
        } else {
            groupedNav.hideSectionTab('handouts');
            groupedNav.hideSectionTab('growthcharts');
            groupedNav.showSectionTab('prenatalfs');
        }
        prePopulateAttachments(spec.attachments);

        renderAttachments(); // render the attachments list on the bottom
        doHighlighting(); // make sure the appropriate items are selected
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);

        clearHighlighting(); // don't keep selected item state around
        attachedItems = {};
        callbackFn = null;
    };

    /* We want the bottom section (where attached items are listed) to float, rather than
     * scrolling along with the whole dialog. To do that, we set the height of the top section
     * and give it an overflow property, so that the bottom section always takes up a fixed
     * amount of space, and the top section uses whatever is left */
    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        super_adjustPosition.call(that); //let the dialog contents adapt to the screen size first

        //then adjust the top section so the bottom section doesn't get pushed down
        var content = that.getContentElt();
        var totalHeight = content.height();
        var $topListLHS = $('.select-attachments-nav', content);
        var $topListRHS = $('.select-attachments-content', content);
        var $bottomList = $('.attached-item-section', content);
        var height = totalHeight - $bottomList.outerHeight();
        $topListLHS.height(height - parseInt($topListLHS.css('top'), 10));
        $topListRHS.height(height - ($topListRHS.outerHeight() - $topListRHS.height()));
    };

    that.ensureFeedRefresh = function(name) {
        var feed = el8.appchart.letters.attachmentGroups.getFeedByName(name);
        if (!feed) { return; }
        if (groupedNav.getShowingSection() === name) {
            feed.update();
        } else {
            feed.markNeedsUpdate();
        }
    };

    /* Makes an async call and returns a list of IDs to callbackFn
     *
     * Note that this function does no UI updating - callers will
     * need to update after it returns.  It also does not save the
     * letter.
     */
    that.getAllAttachments = function(addAttachmentsFn, doneFn) {
        var BATCH_SIZE = 100;
        $.el8_ajax({
            type: 'GET',
            url: el8Globals['PATIENT_PATH'] + 'chart-feed-index/?all_orders=1',
            success: function(index) {
                // Non-attachable types like *MedOrder*, RxHistoryDownloadSummary, and
                // PrenatalFlowsheetVisitMeasurements are not returned by the BE
                var indexIds = _.pluck(index, 'id');

                /* First add all of the printouts */
                var printoutNames = el8.data.attachablePrintouts.filter(function(p) {
                    // don't attach growth charts and use the CompMedsList, instead of the MedsList
                    return (p.indexOf('Chart') === -1 && p !== 'MedsList');
                });
                addAttachmentsFn({attachmentIds: printoutNames, noRender: true});

                /* Then fetch all of the attachments in async batches so we that we don't have
                 * to synchronously fetch them one-by-one in createLetterAttachment and also
                 * don't timeout our connection to the server */
                var itemCount = indexIds.length;
                var batchCount = Math.ceil(itemCount / BATCH_SIZE);

                // every batch will call this when done; after batchCount calls, doneFn will run
                var batchCheckedIn = (doneFn) ? _.after(batchCount, doneFn) : null;
                var fetchBatch = function(batchIds) {
                    el8.ptdata.fetch({
                        fetchIds: batchIds,
                        async: true,
                        callbackFn: function() {
                            // These async calls to addAttachmentsFn could cause a race condition _IF_
                            // JS were a multi-threaded language... because there is only one thread,
                            // we should never end up accidentally missing some attachments from another
                            // batch, though the order is entirely arbitrary.
                            addAttachmentsFn({attachmentIds: batchIds, noRender: true});
                            if (batchCheckedIn) { batchCheckedIn(); }
                        }
                    });
                };

                for (var i=0; i <= itemCount; i += BATCH_SIZE) {
                    var batch = indexIds.slice(i, i+BATCH_SIZE);
                    fetchBatch(batch);
                }
            }
        });
    };

    that.addReportTabAfterPageLoad = function(rTypeId) {
        // the letter attachment dialog has not been opened yet, we don't need to do anything special
        if (!groupedNav) { return; }

        var $group = groupedNav.getGroupElt('Reports');
        groupedNav.addSection($group, el8.appchart.letters.attachmentGroups.getReportFeedSpec(rTypeId));
    };

    /*-----------------------------
      Helper Functions
    -------------------------------*/
    // Takes an entity ID and creates a letterAttachment for that object to add to attachedItems.
    // For visit notes/letters/referral letters, calls helpers to ask the user if they want to attach
    // the documents referenced by the original attachment
    function attachItem(id) {
        var item;
        id = parseInt(id, 10);
        if (isNaN(id)) { return; } // just in case

        var stringId = String(id);
        attachedItems[stringId] = el8.ptdata.letters.createLetterAttachment({ entityId: id });

        if (el8.model.idToModelClass(id) === 'VisitNote') {
            var item = el8.ptdata.fetch({ fetchId: id });
            handleReferencedReports(item);
        } else if (el8.model.idToModelClass(id) === 'Letter') {
            var item = el8.ptdata.fetch({ fetchId: id });
            handleLetterAttachments(item.getAttachments());
        } else if (el8.model.idToModelClass(id) === 'LetterReceipt') {
            var item = el8.ptdata.fetch({ fetchId: id });
            handleLetterReceiptAttachments(item);
        } else if (el8.model.idToModelClass(id) === 'ReferralOrder') {
            var item = el8.ptdata.fetch({ fetchId: id });
            // sometimes a referral order has attachments (referral letter)
            handleLetterAttachments(item.getAttachments());
        }
    }

    // Attach either an entity or a printout
    function attachUnknown(id) {
        var stringId = String(id);
        if (_.contains(el8.data.attachablePrintouts, stringId)) {
            // printouts
            attachedItems[stringId] = el8.ptdata.letters.createLetterAttachment({ printoutName: stringId });
        } else {
            // documents and handouts
            attachItem(id);
        }
    }

    function bindTriggers() {
        var $contentContainer = $('.select-attachments-content', that.getContentElt());
        var $attachmentList = $('.attachments-list', that.getContentElt());
        var $both = $('.select-attachments-content, .attachments-list', that.getContentElt());

        $contentContainer.on('click', '.attachment-checkbox',  function(e) {
            // clicking on the checkbox already toggles its checked state
            var $this = $(this);
            var $attachmentDiv = $this.parents('.attachment-div');
            $attachmentDiv.toggleClass('el8BlueHighlightList');

            changeAttachedState($attachmentDiv.data('id'), $this.is(':checked'));
            e.stopPropagation(); // and we don't need to trigger .attachment-div after this
        });

        // shared code for clicking on an attachment div directly or clicking on an X button
        var attachmentDivClickFn = function($this) {
            if (!$this || !$this.length) { return; }

            $this.toggleClass('el8BlueHighlightList');
            var checkBox = $this.find('input');
            checkBox.prop('checked', !checkBox.is(':checked')); //toggle the checkbox's state
            changeAttachedState($this.data('id'), checkBox.is(':checked'));
        };

        $contentContainer.on('click', '.attachment-div',  function() {
            attachmentDivClickFn($(this));
        });

        $both.on('click', '.item-details-trigger',  function() {
            var id = $(this).data('id');
            if (el8.model.idToModelClass(id) === 'Handout') {
                el8.data.educationalHandouts.downloadById(id);
            } else {
                el8.appchart.showItemDetail(id);
            }
            return false;
        });

        $attachmentList.on('click', '.remove-attachment',  function() {
            var $this = $(this);
            var $div;

            // try to find the .attachment-div corresponding to the attachment being removed
            var id = $this.data('id');
            var $div = getAttachmentDivById(id);

            if ($div && $div.length) {
                // if we found one, do the same stuff we would do it were clicked on
                attachmentDivClickFn($div);
            } else {
                // otherwise, this came from a visit note's referenced reports and was never
                // rendered / clicked on by the user - just remove the attachment
                changeAttachedState(id, false);
            }
        });

        // signed off reports actually get added with a call in reportFeeds.js' signOffCallBackFn
        el8.ptdata.reports.bind('all', function(eventName, arg, arg2) {
            if (eventName === EVENTS.MOVED) {
                // update both feeds that changed for a moved report
                var updatedReport = arg;
                var oldType = arg2;
                that.ensureFeedRefresh(updatedReport.getReportType());
                that.ensureFeedRefresh(oldType);
            } else {
                // for all other events, just refresh this report's feed
                that.ensureFeedRefresh(arg.getReportType());
            }
            // and always refresh the popular feed, in case the report was in there
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.visitNotes.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('popular');
            that.ensureFeedRefresh('visitnotes');
        });
        // visitNoteEdits are handled in the sign function of the visit note model
        el8.ptdata.nonvisitNotes.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('popular');
            that.ensureFeedRefresh('nonvisitnotes');
        });
        el8.data.educationalHandouts.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('handouts');
        });
        el8.ptdata.referralOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('referral-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.cardiacOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('cardiac-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.imagingOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('imaging-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.labOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('lab-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.pulmonaryOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('pulmonary-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.sleepOrders.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('sleep-orders');
            that.ensureFeedRefresh('popular');
        });
        el8.ptdata.messageThreads.bind('all', function(eventName, arg) {
            that.ensureFeedRefresh('messages');
        });
        el8.ptdata.letters.bind('all', function(eventName, letter) {
            if (eventName === EVENTS.DELETED || eventName === EVENTS.CREATED) {
                // sometimes 'letter' is null - we'll be conservative in those cases and update
                if (!letter || letter.isSignedOff()) {
                    that.ensureFeedRefresh('letters');
                }
            }
        });
    }

    // If newlyAttached is true, attach this item; if it's false, remove the attachment.
    // Then re-render the attachments list.
    function changeAttachedState(itemId, newlyAttached) {
        var stringId = String(itemId);
        if (!newlyAttached) {
            delete attachedItems[stringId];
        } else {
            attachUnknown(itemId);
        }
        renderAttachments();
    }

    // Used by attachmentGroups to see if an item should be rendered as selected
    function checkIsAttached(mClass, item) {
        if (_.contains(el8.data.attachablePrintouts, mClass)) {
            return Boolean(attachedItems[mClass]);
        } else if (item) {
            return Boolean(attachedItems[String(item.getId())]);
        }
        return false;
    }

    function clearHighlighting() {
        $('input', that.getContentElt()).prop('checked', false);
        $('.el8BlueHighlightList', that.getContentElt()).removeClass('el8BlueHighlightList');
    }
    function doHighlighting() {
        var selectDiv = function($div) {
            $div.addClass('el8BlueHighlightList');
            $div.find('input').prop('checked', true);
        };

        for (var id in attachedItems) {
            if (attachedItems.hasOwnProperty(id)) {
                selectDiv(getAttachmentDivById(id));
            }
        }
    }

    // id might be a pseudo_class for printouts
    function getAttachmentDivById(id) {
        return $('.attachment-div[data-id="'+id+'"]', that.getContentElt());
    }

    // Ask the user to attach reports referenced by a visit note
    function handleReferencedReports(visitNote) {
        if (visitNote.isImportedNote()) { return; }

        var referencedIds = visitNote.getReferencedReportIds();
        if (!referencedIds.length) { return; }
        var referencedReports = el8.ptdata.fetch(
            referencedIds.map(function(r) {
                return { id: r, model_class: 'Report' };
            })
        );
        var reportSoyMaps = referencedReports.map(function(r) {
            if (r) { return r.asSoyMap(); }
        });

        var addReportsFn = function() {
            referencedReports.forEach(function(r) {
                attachItem(r.getId());
            });
            doHighlighting();
            renderAttachments();
        };
        el8.appchart.letters.relatedAttachmentsPrompt.show({
            documentSoyMaps: reportSoyMaps,
            callbackFn: addReportsFn
        });
    }

    // Ask the user to attach the attachments of another letter
    function handleLetterAttachments(attachments) {
        attachments = attachments.filter(function(a) {
            var type = a.getAttachmentType();
            return (type !== 'RefPanel' && type !== 'PatientDemog');
        });
        if (!attachments.length) { return; }

        var attachmentMaps = attachments.map(el8.model.toSoyMapFn);

        var addAttachmentsFn = function() {
            attachments.map(function(a) {
                attachUnknown(a.getAttachmentKey());
            });
            doHighlighting();
            renderAttachments();
        };
        el8.appchart.letters.relatedAttachmentsPrompt.show({
            attachmentSoyMaps: attachmentMaps,
            callbackFn: addAttachmentsFn
        });
    }


    // Ask the user to attach the filed attachments from a LetterReceipt
    function handleLetterReceiptAttachments(receipt) {
        var attachments = receipt.getAttachments();
        attachments = attachments.filter(function(a) {
            return Boolean(a.getEntityId()); // entityId exists -> filed
        });
        if (!attachments.length) { return; }

        var attachmentMaps = attachments.map(el8.model.toSoyMapFn);

        var addAttachmentsFn = function() {
            attachments.map(function(a) {
                attachItem(a.getEntityId());
            });
            doHighlighting();
            renderAttachments();
        };
        el8.appchart.letters.relatedAttachmentsPrompt.show({
            attachmentSoyMaps: attachmentMaps,
            callbackFn: addAttachmentsFn
        });
    }

    function prePopulateAttachments(itemList) {
        if (!itemList) { return; }

        for (var i=0; i < itemList.length; i++) {
            var stringId = String(itemList[i].getAttachmentKey());
            attachedItems[stringId] = itemList[i];
        }
    }

    // Re-renders the attachments list at the bottom of the dialog
    function renderAttachments() {
        $('.attachments-list', that.getContentElt()).html(
            el8.template.appchart.letters.selectAttachments.attachmentList({
                attachments: _.values(attachedItems).map(el8.model.toSoyMapFn),
                renderEmptyText: true
            })
        );
    }

    return that;

})();
